/**
 * @generated SignedSource<<a07413a77693b5a52df3419213cbdfaf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DelegateDialogQuery$variables = {
  currentAccountAddress: string;
  skipCurrentAccount: boolean;
  targetAccountAddress: string;
};
export type DelegateDialogQuery$data = {
  readonly currentAccount?: {
    readonly amountOwned: {
      readonly amount: {
        readonly " $fragmentSpreads": FragmentRefs<"TokenAmountAsCurrencyDisplayFragment">;
      };
    };
  };
  readonly delegate: {
    readonly address: {
      readonly resolvedName: {
        readonly address: string;
        readonly " $fragmentSpreads": FragmentRefs<"NounResolvedLinkFragment">;
      };
    };
    readonly tokensRepresented: {
      readonly amount: {
        readonly " $fragmentSpreads": FragmentRefs<"TokenAmountAsCurrencyDisplayFragment">;
      };
    };
  };
};
export type DelegateDialogQuery = {
  response: DelegateDialogQuery$data;
  variables: DelegateDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currentAccountAddress"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipCurrentAccount"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "targetAccountAddress"
},
v3 = [
  {
    "kind": "Variable",
    "name": "addressOrEnsName",
    "variableName": "targetAccountAddress"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TokenAmount",
    "kind": "LinkedField",
    "name": "amount",
    "plural": false,
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "TokenAmountAsCurrencyDisplayFragment"
      }
    ],
    "storageKey": null
  }
],
v6 = [
  {
    "kind": "Variable",
    "name": "addressOrEnsName",
    "variableName": "currentAccountAddress"
  }
],
v7 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TokenAmount",
    "kind": "LinkedField",
    "name": "amount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "decimals",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DelegateDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Delegate",
        "kind": "LinkedField",
        "name": "delegate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ResolvedName",
                "kind": "LinkedField",
                "name": "resolvedName",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "NounResolvedLinkFragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VotingPower",
            "kind": "LinkedField",
            "name": "tokensRepresented",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "condition": "skipCurrentAccount",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "currentAccount",
            "args": (v6/*: any*/),
            "concreteType": "Delegate",
            "kind": "LinkedField",
            "name": "delegate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "VotingPower",
                "kind": "LinkedField",
                "name": "amountOwned",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "DelegateDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Delegate",
        "kind": "LinkedField",
        "name": "delegate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ResolvedName",
                "kind": "LinkedField",
                "name": "resolvedName",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VotingPower",
            "kind": "LinkedField",
            "name": "tokensRepresented",
            "plural": false,
            "selections": (v7/*: any*/),
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      {
        "condition": "skipCurrentAccount",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "currentAccount",
            "args": (v6/*: any*/),
            "concreteType": "Delegate",
            "kind": "LinkedField",
            "name": "delegate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "VotingPower",
                "kind": "LinkedField",
                "name": "amountOwned",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "9b5b46afb616896e40bab33e1b24a0f8",
    "id": null,
    "metadata": {},
    "name": "DelegateDialogQuery",
    "operationKind": "query",
    "text": "query DelegateDialogQuery(\n  $targetAccountAddress: String!\n  $currentAccountAddress: String!\n  $skipCurrentAccount: Boolean!\n) {\n  delegate(addressOrEnsName: $targetAccountAddress) {\n    address {\n      resolvedName {\n        address\n        ...NounResolvedLinkFragment\n      }\n    }\n    tokensRepresented {\n      amount {\n        ...TokenAmountAsCurrencyDisplayFragment\n      }\n    }\n    id\n  }\n  currentAccount: delegate(addressOrEnsName: $currentAccountAddress) @skip(if: $skipCurrentAccount) {\n    amountOwned {\n      amount {\n        ...TokenAmountAsCurrencyDisplayFragment\n      }\n    }\n    id\n  }\n}\n\nfragment NounResolvedLinkFragment on ResolvedName {\n  address\n  ...NounResolvedNameFragment\n}\n\nfragment NounResolvedNameFragment on ResolvedName {\n  address\n  name\n}\n\nfragment TokenAmountAsCurrencyDisplayFragment on TokenAmount {\n  amount\n  decimals\n  currency\n}\n"
  }
};
})();

(node as any).hash = "1d57ce8ed4bd295db11e9ac0c7e2102b";

export default node;
